var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionCircleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.688 10.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Zm.24-.75h-.5a.375.375 0 0 1-.375-.375v-.012c0-2.198 2.42-1.988 2.42-3.356 0-.626-.555-1.257-1.795-1.257-.91 0-1.383.302-1.85.897a.374.374 0 0 1-.508.074l-.41-.286a.374.374 0 0 1-.083-.537c.663-.85 1.45-1.398 2.851-1.398 1.635 0 3.045.93 3.045 2.507 0 2.106-2.42 1.995-2.42 3.356V9.5a.375.375 0 0 1-.375.375Zm-.24-8.625a6.75 6.75 0 0 1 0 13.5A6.748 6.748 0 0 1 1.938 8a6.75 6.75 0 0 1 6.75-6.75Zm0-1a7.751 7.751 0 0 0 0 15.5 7.75 7.75 0 1 0 0-15.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.688 0h16v16h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleWhite);
export default __webpack_public_path__ + "static/media/question-circle-white.5721e28d629b62cf963274146d0c82dd.svg";
export { ForwardRef as ReactComponent };